import { useTranslations } from 'next-intl';
import React from 'react';

import FilterGroup from '@/app/[locale]/(default-layout)/program/_components/filter/FilterGroup';

import { useProgramFilterContext } from '@/providers/ProgramFilterProvider';

type FilterGroupsProps = {
    classNameFilterItem?: string;
};

const FilterGroups: React.FC<FilterGroupsProps> = ({ classNameFilterItem }) => {
    const t = useTranslations();
    const { filterGroups, setFilter } = useProgramFilterContext();
    return (
        <div className="flex flex-col justify-between">
            <div className="flex flex-col space-y-24">
                {filterGroups.map((filterGroup) => (
                    <FilterGroup
                        key={filterGroup.groupLabel}
                        classNameFilterItem={classNameFilterItem}
                        label={t(`program.${filterGroup.groupLabel}`)}
                        filters={filterGroup.filters}
                        onFilterClick={(filter) => setFilter(filter, filterGroup)}
                    />
                ))}
            </div>
        </div>
    );
};

export default FilterGroups;
